import { Alert, Box, Snackbar, Typography } from "@mui/material";
import { isNil } from "lodash";
import { useCallback, useEffect, useState } from "react";
import type { QueueOverview } from "../../types/queue-types";
import { getQueues } from "../../utils/queue-api";
import JobList from "./job-list";
import QueueList from "./queue-list";

const QueuesDashboard = () => {
  const [queues, setQueues] = useState<QueueOverview[]>([]);
  const [selectedQueue, setSelectedQueue] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const fetchQueues = useCallback(async () => {
    setLoading(true);
    try {
      const response = await getQueues();
      setQueues(response.queues);
      setError(null);
    } catch (error_) {
      const errorMessage =
        error_ instanceof Error ? error_.message : "Failed to fetch queues";
      setError(errorMessage);
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void fetchQueues();
  }, [fetchQueues]);

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4">Queues dashboard</Typography>
      </Box>

      {isNil(selectedQueue) ? (
        <QueueList
          loading={loading}
          queues={queues}
          onRefresh={fetchQueues}
          onSelectQueue={setSelectedQueue}
        />
      ) : (
        <JobList
          queueName={selectedQueue}
          onBack={() => {
            setSelectedQueue(null);
          }}
          onRefresh={fetchQueues}
        />
      )}

      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        autoHideDuration={6000}
        open={snackbarOpen}
        onClose={handleCloseSnackbar}
      >
        <Alert
          severity="error"
          sx={{ width: "100%" }}
          onClose={handleCloseSnackbar}
        >
          {error}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default QueuesDashboard;
